import { useState } from 'react';
import axios from 'axios';
import './JoinForm.css';
import { API_BASE_URL } from '../api/config';


// Material Icons CDN
const arrowBackSvg = (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#69c891" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
);

function JoinForm({ onSignup }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [nickname, setNickname] = useState('');
  const [location, setLocation] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(
        `${API_BASE_URL}/api/auth/signup`,
        { username, password, nickname, location },
        { timeout: 90000 }
      );
      alert('회원가입 성공!');
      if (onSignup) onSignup();
    } catch (error) {
      let msg = error.response?.data?.message || error.message || '서버 오류';
      if (error.code === 'ECONNABORTED') {
        msg = '서버 응답이 늦습니다. 잠시 후 다시 시도하세요.';
      } else if (error.code === 'ERR_NETWORK' || !error.response) {
        msg = '서버에 연결할 수 없습니다. 잠시 후 다시 시도하세요.';
      }
      alert('회원가입 실패: ' + msg);
    }
  };

  return (
    <div className="join-container">
      <button
        type="button"
        className="back-btn"
        onClick={onSignup}
        style={{
          position: 'fixed',
          top: '24px',
          left: '24px',
          background: 'none',
          border: 'none',
          padding: 0,
          zIndex: 1000,
          cursor: 'pointer',
        }}
        aria-label="뒤로가기"
      >
        <span style={{ display: 'flex', alignItems: 'center', gap: '6px', fontFamily: 'TmoneyRoundWindExtraBold, Noto Sans KR, sans-serif', color: '#69c891', fontSize: '1.15rem' }}>
          {arrowBackSvg}
          로그인
        </span>
      </button>
      <form className="join-form" onSubmit={handleSubmit}>
        <img src="/images/logoColor.png" alt="공구나라 컬러 로고" className="join-logo" />
        <h2 className="join-title">회원가입</h2>
        <label htmlFor="username" className="join-label">아이디</label>
        <input
          type="text"
          id="username"
          name="username"
          className="join-input"
          value={username}
          onChange={e => setUsername(e.target.value)}
          required
        />
        <label htmlFor="password" className="join-label">비밀번호</label>
        <input
          type="password"
          id="password"
          name="password"
          className="join-input"
          value={password}
          onChange={e => setPassword(e.target.value)}
          required
        />
        <label htmlFor="nickname" className="join-label">닉네임</label>
        <input
          type="text"
          id="nickname"
          name="nickname"
          className="join-input"
          value={nickname}
          onChange={e => setNickname(e.target.value)}
          required
        />
        <label htmlFor="location" className="join-label">거주지역</label>
        <input
          type="text"
          id="location"
          name="location"
          className="join-input"
          value={location}
          onChange={e => setLocation(e.target.value)}
          required
        />
        <button type="submit" className="join-btn">가입하기</button>
      </form>
    </div>
  );
}

export default JoinForm;